import React from "react";
import { Button } from "antd";
import styled from "styled-components";

const ButtonContainer = styled.div`
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 2px;
  width: 100%;
`;

// TODO: Refactor styling to use styled-components
const ModalButton = ({ onClick, children, ...rest }: any) => (
  <ButtonContainer>
    <Button
      className="modal-button"
      type="primary"
      onClick={onClick}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      style={{ width: "100%" }}
    >
      {children}
    </Button>
  </ButtonContainer>
);

export default ModalButton;
